import TableText from "@/components/common/TableText";
import { Eye, Pencil, Trash2, Link2, Navigation } from "lucide-react";

export const getSubNavigationColumns = ({ onView, onEdit, handleDelete }) => [
  /* ---------------- SUB NAVIGATION ---------------- */
  {
    key: "SubNavigationName",
    label: "Sub Navigation",

    render: (row) => {
      const hasImage = !!row.SubNavigationIcon;

      return (
        <div
          onClick={() => onView(row)}
          className="
            flex items-center gap-3 min-w-0 cursor-pointer
            rounded-lg p-2 -m-2
            hover:bg-slate-50 dark:hover:bg-slate-800
            transition-all
          "
        >
          <div className="w-10 h-10 rounded-xl bg-cyan-500/10 flex items-center justify-center overflow-hidden">
            {hasImage ? (
              <img
                src={row.SubNavigationIcon}
                alt="icon"
                className="w-6 h-6 object-contain"
              />
            ) : (
              <Navigation className="w-5 h-5 text-cyan-500" />
            )}
          </div>

          <div className="min-w-0 flex-1">
            <TableText
              title={row.SubNavigationName}
              subtitle={`${row.BaseNavigationName} • ${row.NavigationName}`}
              multiline
              maxLines={2}
            />
          </div>
        </div>
      );
    },
  },

  /* ---------------- ACCOUNT TYPE ---------------- */
  {
    key: "AccountTypeName",
    label: "Account Type",
    width: 140,

    render: (row) => (
      <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-blue-500/10 text-blue-600 dark:text-blue-400">
        {row.AccountTypeName}
      </span>
    ),
  },

  /* ---------------- NAVIGATION ---------------- */
  {
    key: "NavigationName",
    label: "Navigation",
    width: 180,

    render: (row) => (
      <TableText title={row.NavigationName} subtitle={row.BaseNavigationName} />
    ),
  },

  /* ---------------- URL ---------------- */
  {
    key: "SubNavigationURL",
    label: "URL",

    render: (row) => (
      <div className="flex items-center gap-2 max-w-xs">
        <Link2 className="w-4 h-4 text-slate-400 shrink-0" />

        <span
          className="truncate text-sm text-slate-600 dark:text-slate-300"
          title={row.SubNavigationURL}
        >
          {row.SubNavigationURL}
        </span>
      </div>
    ),
  },

  /* ---------------- SEQUENCE ---------------- */
  {
    key: "SequenceNo",
    label: "Sequence",
    width: 100,

    render: (row) => (
      <span className="font-medium text-slate-900 dark:text-white">
        {row.SequenceNo}
      </span>
    ),
  },

  /* ---------------- STATUS ---------------- */
  {
    key: "IsActive",
    label: "Status",
    width: 100,

    render: (row) => (
      <span
        className={`px-2.5 py-1 rounded-full text-xs font-medium ${
          row.IsActive
            ? "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
            : "bg-red-500/10 text-red-600 dark:text-red-400"
        }`}
      >
        {row.IsActive ? "Active" : "Inactive"}
      </span>
    ),
  },

  /* ---------------- CREATED BY ---------------- */
  {
    key: "CreatedBy",
    label: "Created By",
    width: 130,

    render: (row) => (
      <span className="text-sm text-slate-600 dark:text-slate-300">
        {row.CreatedBy || "-"}
      </span>
    ),
  },

  /* ---------------- CREATED ON ---------------- */
  {
    key: "CreatedOn",
    label: "Created On",
    width: 140,

    render: (row) => (
      <span className="text-sm text-slate-600 dark:text-slate-300">
        {row.CreatedOn
          ? new Date(row.CreatedOn).toLocaleDateString("en-IN")
          : "-"}
      </span>
    ),
  },

  /* ---------------- ACTIONS ---------------- */
  {
    key: "actions",
    label: "Actions",

    render: (row) => (
      <div className="flex items-center gap-2">
        <button
          onClick={() => onView(row)}
          className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
        >
          <Eye className="w-4 h-4 text-slate-600" />
        </button>

        <button
          onClick={() => onEdit(row)}
          className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
        >
          <Pencil className="w-4 h-4 text-blue-500" />
        </button>

        <button
          onClick={() => handleDelete(row)}
          className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
        >
          <Trash2 className="w-4 h-4 text-red-500" />
        </button>
      </div>
    ),
  },
];
